<template>
  <div>
    <h2>Modifier l’association</h2>
    <div class="add-association">
      <form @submit.prevent="submitForm">
        <label>Nom :</label>
        <input type="text" v-model="form.name" required />

        <label>Description :</label>
        <textarea
          class="text-editor"
          v-model="form.description"
          placeholder="Saisir une description simple"
          required
        ></textarea>

        <label>Contenu enrichi :</label>
        <div ref="quillEditor" class="text-editor"></div>

        <label>Image (laisser vide pour ne pas changer) :</label>
        <input type="file" @change="handleImage" accept=".jpg,.jpeg,.png,.webp" />

        <label>Latitude :</label>
        <input type="number" step="any" v-model="form.latitude" required />

        <label>Longitude :</label>
        <input type="number" step="any" v-model="form.longitude" required />

        <label>Lieux :</label>
        <div class="checkbox-group">
          <div v-for="lieu in allLieux" :key="`lieu-${lieu.id}`">
            <input
              type="checkbox"
              :id="`lieu-${lieu.id}`"
              :value="lieu.id"
              v-model="form.place"
            />
            <label :for="`lieu-${lieu.id}`">{{ lieu.title }}</label>
          </div>
        </div>

        <label>Publics :</label>
        <div class="checkbox-group">
          <div v-for="pub in allPub" :key="`pub-${pub.id}`">
            <input
              type="checkbox"
              :id="`pub-${pub.id}`"
              :value="pub.id"
              v-model="form.publics"
            />
            <label :for="`pub-${pub.id}`">{{ pub.title }}</label>
          </div>
        </div>

        <label>Accessibilité :</label>
        <div class="checkbox-group">
          <div v-for="acc in allAccessibilities" :key="`acc-${acc.id}`">
            <input
              type="checkbox"
              :id="`acc-${acc.id}`"
              :value="acc.id"
              v-model="form.accessibility"
            />
            <label :for="`acc-${acc.id}`">{{ acc.title }}</label>
          </div>
        </div>

        <label>Contexte d'intervention :</label>
        <div class="checkbox-group">
          <div v-for="cont in allContexts" :key="`cont-${cont.id}`">
            <input
              type="checkbox"
              :id="`cont-${cont.id}`"
              :value="cont.id"
              v-model="form.context"
            />
            <label :for="`cont-${cont.id}`">{{ cont.title }}</label>
          </div>
        </div>

        <label>Catégories :</label>
          <div class="checkbox-group">
          <CategoryTreeCheckbox
            v-for="root in allCategories"
            :key="root.id"
            :node="root"
            v-model="form.category"
          />
        </div>

        <button type="submit">Enregistrer</button>
        <button type="button" @click="$emit('close')">Annuler</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import CategoryTreeCheckbox from './CategoryTreeCheckbox.vue'

export default {
  name: 'EditAssociationForm',
  components: {CategoryTreeCheckbox},
  props: { association: { type: Object, required: true } },
  data() {
    return {
      file: null,
      form: {
        id: this.association.id,
        name: this.association.name,
        description: this.association.description,
        content: this.association.content || '',
        latitude: this.association.latitude,
        longitude: this.association.longitude,
        place: [...this.association.place],
        category: [...this.association.category],
        publics:[...this.association.public],
        accessibility:[...this.association.accessibility],
        context:[...this.association.context]
      },
      quill: null
    };
  },
  computed: {
    ...mapGetters(['getCategories', 'getPlaces', 'getPublics', 'getAccessibilities', 'getContexts']),
    allCategories() { return this.getCategories; },
    allLieux() { return this.getPlaces; },
    allPub() { return this.getPublics;},
    allAccessibilities(){return this.getAccessibilities;},
    allContexts(){return this.getContexts;}
  },
  mounted() {
    this.quill = new Quill(this.$refs.quillEditor, {
      theme: 'snow',
      modules: {
        toolbar: [['bold','italic','underline'],[{ list:'ordered'},{ list:'bullet'}],['link','clean']],
        clipboard: { matchVisual: false }
      }
    });
    this.quill.root.innerHTML = this.form.content;
    this.quill.on('text-change', () => { this.form.content = this.quill.root.innerHTML; });
  },
  methods: {
    handleImage(e) { this.file = e.target.files[0]; },
    submitForm() {
      const formData = new FormData(); if (this.file) formData.append('file', this.file);
      const payload = { id:this.form.id, name:this.form.name, description:this.form.description, content:this.form.content, latitude:parseFloat(this.form.latitude), longitude:parseFloat(this.form.longitude), place:this.form.place, category:this.form.category, public: this.form.publics, accessibility: this.form.accessibility, context:this.form.context};
      formData.append('associationUpdate', JSON.stringify(payload));
      this.$store.dispatch('updateAssociation', formData).then(()=>this.$emit('close'));
    }
  },
  created() {
    if (!this.getCategories.length) this.$store.dispatch('loadAssociationCategories');
    if (!this.getPlaces.length) this.$store.dispatch('loadAssociationPlaces');
    if (!this.getPublics.length) this.$store.dispatch('loadAssociationPublics');
    if (!this.getAccessibilities.length) this.$store.dispatch('loadAssociationAccessibilities');
    if (!this.getContexts.length) this.$store.dispatch('loadAssociationContexts');
  }
};
</script>
<style scoped>
.add-association{background-color:#F8F8FF;border-radius:10px;padding:2rem;border:1px solid #ccc;text-align:left}
form{display:flex;flex-direction:column}
label{font-weight:bold;margin-top:1rem;margin-bottom:.25rem;color:#5E3B80}
input[type="text"],input[type="number"],textarea,.ql-container{padding:.5rem;border:1px solid #ccc;border-radius:6px;font-size:1rem;width:100%}
textarea,.text-editor{min-height:150px;resize:vertical;overflow-y:auto}
.ql-container{min-height:150px}
.checkbox-group{display:flex;flex-direction:column;gap:.5rem;margin-top:.5rem}
.checkbox-group label{margin-left:.5rem;font-weight:normal;color:#333}
button{margin-top:2rem;background-color:#167580;color:white;border:none;padding:.75rem;font-weight:bold;border-radius:8px;cursor:pointer;transition:background-color .2s}
button:hover{background-color:#1E1C66}
</style>
